import { DeleteSharp, EditSharp } from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  Grid,
  IconButton,
  Modal,
  Stack,
  TextField,
  Tooltip,
  Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import {
  getLeaveTypes,
  insertLeaveType,
  updateLeaveType,
  deactivateLeaveType
} from "src/api/leaveTypes";
import Page from "src/components/Page";
import { notification } from "src/utils/messages";
import Deletemodal from "./DeleteModal";
import CustomLoader from "src/commonComponents/CustomLoader";
import { FormControl, InputLabel, MenuItem, Select, Switch, FormControlLabel } from "@mui/material";

const GENDERS = [
  { value: 0, label: "All" },
  { value: 1, label: "Male" },
  { value: 2, label: "Female" }
];

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 760,
  maxWidth: "92vw",
  bgcolor: "background.paper",
  boxShadow: 10,
  borderRadius: "10px",
  p: 2
};

export default function LeaveTypes() {
  const [addEditModal, setAddEditModal] = useState(false);
  const [leaveTypeData, setLeaveTypeData] = useState({
    leave_type_title: "",
    leave_type_days: 30
  });
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [dvisible, setDvisible] = useState({ mval: false, id: 0 });
  const [response, setresponse] = useState(0);

  const toggleAddEditModal = () => setAddEditModal(!addEditModal);
  const resetFormData = () => {
    setLeaveTypeData({
      leave_t_id: undefined,
      title: "",
      duration_days: 30,
      gender: 0,
      proxy_allowed: 0,
      retro_start_days: 0,
      membership_extension_months: 0,
    });
  };

  const getLeaveTypesData = async () => {
    setIsLoading(true);
    let res = await getLeaveTypes(true);
    setIsLoading(false);
    if (res?.status === 1) setTableData(res.output || []);
  };

  const toggleStatus = async (row) => {
    setIsLoading(true);
    try {
      const payload = {
        id: row?.leave_t_id,
        title: row?.title,
        duration_days: row?.duration_days,
        gender: row?.gender,
        proxy_allowed: row?.proxy_allowed ? 1 : 0,
        retro_start_days: row?.retro_start_days,
        membership_extension_months: row?.membership_extension_months,
        documents: Array.isArray(row?.documents) ? row.documents : [],
        status: row?.status ? 0 : 1
      };
      const resp = await updateLeaveType(payload);
      notification({ type: resp?.status == 0 ? "error" : "success", message: resp?.message || "Updated" })();
      if (resp?.status != 0) getLeaveTypesData();
    } catch (e) {
      notification({ type: "error", message: "Action failed" })();
    }
    setIsLoading(false);
  };

  const handleSubmit = async (newData = undefined) => {
    const cur = newData != undefined ? newData : leaveTypeData;
    if (cur.title == "") {
      let notify = notification({ type: "error", message: "Please Fill All Fields data" });
      notify();
      return;
    }
    let payload = {
      id: cur.leave_t_id,
      title: cur.title,
      duration_days: cur.duration_days,
      gender: cur.gender,
      proxy_allowed: cur.proxy_allowed ? 1 : 0,
      retro_start_days: cur.retro_start_days,
      membership_extension_months: cur.membership_extension_months,
      documents: Array.isArray(cur.documents) ? cur.documents : [],
      status: cur.status !== undefined ? cur.status : 1
    };
    setIsLoading(true);
    let resp = cur.leave_t_id ? await updateLeaveType(payload) : await insertLeaveType(payload);
    setIsLoading(false);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
    if (resp.status != 0) {
      resetFormData();
      newData == undefined && toggleAddEditModal();
      getLeaveTypesData();
    }
  };

  const deactivateLeaveTypeFn = async (id) => {
    const resp = await deactivateLeaveType({ id });
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
    if (resp.status == 1) {
      setresponse(response + 1);
      setDvisible({ mval: false, id: 0 });
      getLeaveTypesData();
    }
  };

  useEffect(() => {
    getLeaveTypesData();
  }, [response]);

  const columns = [
    {
      name: "No",
      wrap: true,
      selector: (row) => row?.leave_t_id,
      sortable: true,
      width: "80px"
    },
    {
      name: "Title",
      wrap: true,
      selector: (row) => row?.title,
      sortable: true
    },
    {
      name: "Days",
      wrap: true,
      selector: (row) => row?.duration_days,
      sortable: true,
      width: "80px"
    },
    {
      name: "Gender",
      wrap: true,
      selector: (row) => (GENDERS.find((g) => g.value === row?.gender)?.label || "All"),
      sortable: true,
      width: "80px"
    },
    {
      name: "Action",
      wrap: true,
      sortable: true,
      selector: (row) => (
        <>
          <Tooltip title="Edit">
            <IconButton
              onClick={() => {
                setLeaveTypeData({ ...row, leave_t_id: row?.leave_t_id });
                toggleAddEditModal();
              }}
            >
              <EditSharp color="warning" />
            </IconButton>
          </Tooltip>
          <Tooltip title={row?.status ? "Deactivate" : "Activate"}>
            <Switch
              size="small"
              checked={!!row?.status}
              onChange={() => toggleStatus(row)}
              color="success"
            />
          </Tooltip>
        </>
      )
    }
  ];

  return (
    <>
      <Deletemodal
        visible={dvisible}
        setVisible={setDvisible}
        deletefunc={deactivateLeaveTypeFn}
      />

      <Page title="Leave Types | Local Vocal Business Group">
        <Container>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                <Typography variant="h4" gutterBottom>
                  Leave Types
                </Typography>
              </Stack>
            </Grid>
            <Grid item xs={6}>
              <Button
                onClick={() => (toggleAddEditModal(), resetFormData())}
                style={{ marginBottom: "15px", float: "right" }}
                variant="contained"
              >
                Add Leave Type
              </Button>
            </Grid>
          </Grid>

          <Modal
            open={addEditModal}
            onClose={() => (toggleAddEditModal(), resetFormData())}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                style={{ marginBottom: "5px", textAlign: "center" }}
              >
                Add Leave Type
              </Typography>
              <hr />
              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                <Grid container>
                  <Grid item sm={12} xs={12}>
                    <TextField
                      style={{ marginTop: "15px" }}
                      height={10}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="Title"
                      name="title"
                      placeholder="Enter Title"
                      onChange={(e) => setLeaveTypeData({ ...leaveTypeData, title: e.target.value })}
                      value={leaveTypeData?.title || ""}
                    />
                  </Grid>
                  <Grid item sm={12} xs={12}>
                    <TextField
                      style={{ marginTop: "15px" }}
                      height={10}
                      fullWidth
                      autoComplete="off"
                      type="number"
                      label="Days"
                      name="duration_days"
                      placeholder="Enter Days"
                      onChange={(e) => setLeaveTypeData({ ...leaveTypeData, duration_days: e.target.value })}
                      value={leaveTypeData?.duration_days || ""}
                    />
                  </Grid>
                  <Grid item sm={12} xs={12}>
                    <TextField
                      style={{ marginTop: "15px" }}
                      height={10}
                      fullWidth
                      autoComplete="off"
                      type="number"
                      label="Past start days allowed (backdated)"
                      name="retro_start_days"
                      placeholder="0 = future only"
                      onChange={(e) => setLeaveTypeData({ ...leaveTypeData, retro_start_days: e.target.value })}
                      value={leaveTypeData?.retro_start_days || ""}
                    />
                  </Grid>
                  <Grid item sm={12} xs={12}>
                    <TextField
                      style={{ marginTop: "15px" }}
                      height={10}
                      fullWidth
                      autoComplete="off"
                      type="number"
                      label="Membership months"
                      name="membership_extension_months"
                      placeholder="Enter months"
                      onChange={(e) => setLeaveTypeData({ ...leaveTypeData, membership_extension_months: e.target.value })}
                      value={leaveTypeData?.membership_extension_months || ""}
                    />
                  </Grid>
                  <Grid item sm={12} xs={12}>
                    <FormControlLabel style={{ marginTop: "15px", display: "block" }} control={<Switch checked={!!leaveTypeData?.proxy_allowed} onChange={(e) => setLeaveTypeData({ ...leaveTypeData, proxy_allowed: e.target.checked ? 1 : 0 })} />} label="Allow apply on behalf (proxy)" />
                  </Grid>
                  <Grid item sm={12} xs={12}>
                    <Typography variant="subtitle2" sx={{ mt: 2 }}>Attachments / Documents</Typography>
                    {(leaveTypeData?.documents || []).map((doc, idx) => (
                      <Grid container spacing={1} key={idx} sx={{ mt: 1 }}>
                        <Grid item xs={5}>
                          <TextField fullWidth size="small" label="Name" value={doc.label || ""} onChange={(e) => { const docs = [...leaveTypeData.documents]; docs[idx] = { ...docs[idx], label: e.target.value }; setLeaveTypeData({ ...leaveTypeData, documents: docs }); }} />
                        </Grid>
                        <Grid item xs={2}>
                          <Typography variant="caption" sx={{ color: "#94a3b8", display: "block", mt: 1.5, textAlign: "center" }}>
                            Type #{doc.doc_type || idx + 1}
                          </Typography>
                        </Grid>
                        <Grid item xs={2}>
                          <TextField fullWidth size="small" type="number" label="Max files" value={doc.max_files || 1} onChange={(e) => { const docs = [...leaveTypeData.documents]; docs[idx] = { ...docs[idx], max_files: e.target.value }; setLeaveTypeData({ ...leaveTypeData, documents: docs }); }} />
                        </Grid>
                        <Grid item xs={2}>
                          <FormControlLabel control={<Switch checked={!!doc.is_required} onChange={(e) => { const docs = [...leaveTypeData.documents]; docs[idx] = { ...docs[idx], is_required: e.target.checked ? 1 : 0 }; setLeaveTypeData({ ...leaveTypeData, documents: docs }); }} />} label="Req" />
                        </Grid>
                        <Grid item xs={1}>
                          <Button size="small" color="error" onClick={() => { const docs = leaveTypeData.documents.filter((_, i) => i !== idx); setLeaveTypeData({ ...leaveTypeData, documents: docs }); }}>X</Button>
                        </Grid>
                      </Grid>
                    ))}
                    <Button size="small" variant="outlined" sx={{ mt: 1 }} onClick={() => {
                      const existing = (leaveTypeData?.documents || []).map((d) => parseInt(d.doc_type, 10) || 0);
                      const next = existing.length ? Math.max(...existing) + 1 : 1;
                      setLeaveTypeData({ ...leaveTypeData, documents: [...(leaveTypeData?.documents || []), { label: "", doc_type: next, is_required: 1, min_files: 1, max_files: 5, max_file_size_mb: 20 }] });
                    }}>Add document</Button>
                  </Grid>
                  <Grid item sm={12} xs={12}>
                    <FormControl fullWidth style={{ marginTop: "15px" }}>
                      <InputLabel>Gender</InputLabel>
                      <Select
                        value={leaveTypeData?.gender || 0}
                        label="Gender"
                        onChange={(e) => setLeaveTypeData({ ...leaveTypeData, gender: e.target.value })}
                      >
                        {GENDERS.map((g) => (
                          <MenuItem key={g.value} value={g.value}>
                            {g.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid
                    item
                    sm={12}
                    xs={12}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center"
                    }}
                  >
                    <Button
                      variant="outlined"
                      onClick={() => (toggleAddEditModal(), resetFormData())}
                      style={{ marginTop: "15px", marginRight: "15px" }}
                    >
                      Close
                    </Button>
                    <Button
                      variant="contained"
                      style={{ marginTop: "15px" }}
                      onClick={() => handleSubmit()}
                      disabled={isLoading}
                      startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
                    >
                      Submit
                    </Button>
                  </Grid>
                </Grid>
              </Stack>
            </Box>
          </Modal>

          <Card spacing={3} style={{ padding: "10px", marginTop: "20px" }}>
            <DataTable
              filter
              pagination
              highlightOnHover
              columns={columns}
              data={tableData != null ? tableData : []}
              progressPending={isLoading}
              progressComponent={<CustomLoader />}
            />
          </Card>
        </Container>
      </Page>
    </>
  );
}
